export default __webpack_public_path__ + "static/media/labs-uni-closed-logo.c9860cf7.svg";